import { render } from "./ProductDetail_AiAgent.vue?vue&type=template&id=13c1bf78&scoped=true"
import script from "./ProductDetail_AiAgent.vue?vue&type=script&lang=js"
export * from "./ProductDetail_AiAgent.vue?vue&type=script&lang=js"

import "./ProductDetail_AiAgent.vue?vue&type=style&index=0&id=13c1bf78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c1bf78"]])

export default __exports__